/**
 * @generated SignedSource<<486ec3baa28c36cd0ef4bc1dade52ea9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "walletId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "walletid",
        "variableName": "walletId"
      }
    ],
    "concreteType": "WalletLedgerSummary",
    "kind": "LinkedField",
    "name": "getwalletledgersummary",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payInAr",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetAndFullArBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payInArAvailable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetAndArBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetArAuthBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "balanceForTopupCalc",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "floatBalanceDisplay",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "floatBalanceForAuth",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WalletLedgerSummaryFetchQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WalletLedgerSummaryFetchQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "acb9c2c1266a8e5fdf8a911fb5d6d2c6",
    "id": null,
    "metadata": {},
    "name": "WalletLedgerSummaryFetchQuery",
    "operationKind": "query",
    "text": "query WalletLedgerSummaryFetchQuery(\n  $walletId: UUID!\n) {\n  getwalletledgersummary(walletid: $walletId) {\n    assetBalance\n    payInAr\n    assetAndFullArBalance\n    payInArAvailable\n    assetAndArBalance\n    assetArAuthBalance\n    balanceForTopupCalc\n    authBalance\n    floatBalanceDisplay\n    floatBalanceForAuth\n  }\n}\n"
  }
};
})();

node.hash = "4e5758892f24380d2f6ca4c5d5f748ac";

module.exports = node;
